module.exports = __webpack_public_path__ + "images/9ae3051f09ccaac6568b4a5cd7c69c44.png";